export const getFormattedDuration = (duration) => {
    let [hours, minutes, seconds] = duration.split(":");
  
    hours = hours !== "00" ? hours + " h " : "";
    minutes = minutes !== "00" ? minutes + " min " : "";
    seconds = seconds + " sec";
    
    return hours + minutes + seconds;
  }